module.exports = __webpack_public_path__ + "img/logo.dd235604.png";